import useYWR, { YWRKey } from "@/features/ui/hooks/use-ywr";
import { calcUrl } from "@/features/ui/helpers/fetcher-helpers";
import useFetcher from "@/utils/use-fetcher";
import { ShippingInfo } from "@/features/my-account/types/shipping-info.type";

export interface CreateShippingInfoRequest {
  alias: string;
  recipientName: string;
  contact: string;
  address: string;
  detailAddress: string;
  zipCode: string;
  isDefault: boolean;
}

interface CreateShippingInfoResponse extends ShippingInfo {}

export interface CreateShippingInfoPathParameter {
  companyId: number;
}

export const createShippingInfoTemplateUrl =
  "/buyers/:companyId/shipping-infos";

export const createShippingInfoKey: YWRKey<CreateShippingInfoPathParameter> = {
  url: (parameter) => calcUrl(createShippingInfoTemplateUrl, parameter),
  method: "post",
};

export default function useCreateShippingInfo() {
  const fetcher = useFetcher<CreateShippingInfoRequest, CreateShippingInfoResponse>();
  return useYWR(createShippingInfoKey, fetcher);
}
